export default __webpack_public_path__ + "static/media/pain.430691cd.svg";